import { machineCatalogueActions } from "../../constants/actionTypes";
import { emptyList } from "../../constants/componentConstants";

const INITIAL_STATE = {
  selectedTab: "0",
  skusList: emptyList,
  skusListError: "",
  createCatalog: "",
  editCatalog: "",
  catalogBulkUploadData: "",
  removeSkuData: "",
  addSkuData: "",
  retireSkuData: "",
  publicLabDetails: {},
  cloudBatchList: {},
  standAloneLabs: {},
  batchDetails: {},
  labDetails: {},
  batchLoading: false,
  batchDetailsLoading: false,
  labLoading: false,
  labDetailsLoading: false,
  templateDetailsLoading: false,
  addBatchSuccess: false,
  addBatchError: {},
  deleteLabBatchSuccess: false,
  deleteBatchError: false,
  cloudLabExtensionSuccess: false,
  cloudLabExtensionError: {},
  addLabSuccess: false,
  addLabError: {},
  deleteTemplateSuccess: false,
  deleteTemplateError: {},
  deleteLabSuccess: false,
  linkTenantList: {},
  deletedLinkedTenantSuccess: false,
  linkTenantSuccess: false,
  linkTenantsListLoading: false,
  linkTenantListSuccess: true,
  linkTenantListError: false,
  linkTenantError: {},
  linkTenantLoading: false,
  deleteLinkTenantLoading: false,
  activeLinkedTenant: null,
  commonError: null,
  catalogBulkUploadError: "",
  cloudCred: {},
  cloudLabReProvisionSuccess: "",
  cloudLabReProvisionError: "",
  updatePermissionPolicySuccess: "",
  updatePermissionPolicyError: "",
  workspaceBatchReportsList: {},
  workspaceBatchReportsListError: "",
  workspaceTenantList: "",
  workspaces: "",
  generateWorkspaceBatchReportSuccess: "",
  generateWorkspaceBatchReportError: "",
  azureReportLoading: false,
  azureReportSuccess: false,
  azureReportData: [],
  cleanUpAzureLoading: false,
  cleanUpAzureSuccess: false,
  awsAccountClean: {
    awsCleanupLoading: false,
    awsCleanupSuccess: false,
    awsCleanupError: "",
    awsCleanupData: {},
  },
  mentorListLoading: false,
  mentorList: [],
  mentorListError: null,
};

const resourceManager = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case machineCatalogueActions.SELECTED_TAB:
      return {
        ...state,
        selectedTab: action?.payload,
      };
    case machineCatalogueActions.SKUSLISTSETDATA:
      return {
        ...state,
        skusList: {
          ...action?.payload?.data,
        },
      };
    case machineCatalogueActions.SKUSLISTSETERROR:
      return {
        ...state,
        skusListError: action?.payload?.response,
        skusList: emptyList,
      };
    case machineCatalogueActions.CATALOG_CREATE_SUCCESS:
      return {
        ...state,
        createCatalog: {
          ...action?.data,
        },
      };
    case machineCatalogueActions.CATALOG_CREATE_ERROR:
      return {
        ...state,
        createCatalog: { ...action?.data },
      };
    case machineCatalogueActions.EDIT_CATALOG_SUCCESS:
      return {
        ...state,
        editCatalog: { ...action?.payload },
      };
    case machineCatalogueActions.EDIT_CATALOG_ERROR:
      return {
        ...state,
        editCatalog: { ...action?.data },
      };
    case machineCatalogueActions.CATALOG_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        catalogBulkUploadData: action?.data,
      };
    case machineCatalogueActions.CATALOG_BULK_UPLOAD_ERROR:
      return {
        ...state,
        catalogBulkUploadData: action?.data?.response,
        catalogBulkUploadError: action?.data?.response,
      };
    case machineCatalogueActions.REMOVE_SKU_SUCCESS:
    case machineCatalogueActions.REMOVE_SKU_ERROR:
      return {
        ...state,
        removeSkuData: action?.payload,
      };
    case machineCatalogueActions.ADD_SKU_SUCCESS:
    case machineCatalogueActions.ADD_SKU_ERROR:
      return {
        ...state,
        addSkuData: action?.payload,
      };
    case machineCatalogueActions.RETIRE_SKU_SUCCESS:
    case machineCatalogueActions.RETIRE_SKU_ERROR:
      return {
        ...state,
        retireSkuData: action?.payload,
      };
    case machineCatalogueActions.FETCH_CLOUD_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        publicLabDetails: action?.payload,
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        addBatchError: {},
        addBatchSuccess: false,
        addLabSuccess: false,
        addLabError: {},
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
        deleteTemplateSuccess: false,
      };
    case machineCatalogueActions.FETCH_CLOUD_TEMPLATE_BY_ID_ERROR:
      return {
        ...state,
        publicLabDetails: {},
        batchDetails: {},
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        addBatchError: {},
        addBatchSuccess: false,
        addLabSuccess: false,
        addLabError: {},
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    case machineCatalogueActions.LIST_CLOUD_BATCH_SUCCESS:
      return {
        ...state,
        cloudBatchList: action?.payload,
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
        deleteTemplateSuccess: false,
      };
    case machineCatalogueActions.LIST_CLOUD_BATCH_ERROR:
      return {
        ...state,
        cloudBatchList: {},
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    case machineCatalogueActions.LIST_WORKSPACE_CLOUD_BATCH_SUCCESS:
      return {
        ...state,
        cloudBatchList: action?.payload,
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
        deleteTemplateSuccess: false,
      };
    case machineCatalogueActions.LIST_WORKSPACE_CLOUD_BATCH_ERROR:
      return {
        ...state,
        cloudBatchList: {},
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    case machineCatalogueActions.RESET_CLOUD_BATCH_LIST:
      return {
        ...state,
        cloudBatchList: {},
      };
    case machineCatalogueActions.LIST_CLOUD_LAB_SUCCESS:
      return {
        ...state,
        standAloneLabs: action?.payload,
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
        addLabSuccess: false,
        deleteTemplateSuccess: false,
        deleteLabSuccess: false,
      };
    case machineCatalogueActions.LIST_CLOUD_LAB_ERROR:
      return {
        ...state,
        standAloneLabs: {},
        deleteLabBatchSuccess: false,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
        deleteTemplateSuccess: false,
        deleteLabSuccess: false,
        addLabSuccess: false,
      };
    case machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID_SUCCESS:
      return {
        ...state,
        batchDetails: action?.payload,
        deleteLabBatchSuccess: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
        addBatchSuccess: false,
      };
    case machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID_ERROR:
      return {
        ...state,
        batchDetails: {},
        deleteLabBatchSuccess: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };

    case machineCatalogueActions.FETCH_CLOUD_LAB_BY_ID_SUCCESS:
      return {
        ...state,
        labDetails: action?.payload,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    case machineCatalogueActions.FETCH_CLOUD_LAB_BY_ID_ERROR:
      return {
        ...state,
        labDetails: {},
      };
    case machineCatalogueActions.CREATE_CLOUD_BATCH_SUCCESS: {
      return {
        ...state,
        batchLoading: false,
        addBatchSuccess: true,
        addBatchError: {},
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    }
    case machineCatalogueActions.CREATE_CLOUD_BATCH_ERROR: {
      return {
        ...state,
        batchLoading: false,
        addBatchSuccess: false,
        addBatchError: action.payload,
      };
    }
    case machineCatalogueActions.SET_BATCH_LOADING: {
      return {
        ...state,
        batchLoading: action?.payload,
      };
    }
    case machineCatalogueActions.SET_LAB_LOADING: {
      return {
        ...state,
        labLoading: action?.payload,
      };
    }
    case machineCatalogueActions.SET_TEMPLATE_DETAILS_LOADING: {
      return {
        ...state,
        templateDetailsLoading: action?.payload,
      };
    }
    case machineCatalogueActions.SET_LAB_DETAILS_LOADING: {
      return {
        ...state,
        labDetailsLoading: action?.payload,
      };
    }
    case machineCatalogueActions.SET_BATCH_DETAILS_LOADING: {
      return {
        ...state,
        batchDetailsLoading: action?.payload,
      };
    }
    case machineCatalogueActions.DELETE_CLOUD_BATCH_SUCCESS: {
      return {
        ...state,
        deleteLabBatchSuccess: true,
        deleteBatchError: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    }
    case machineCatalogueActions.DELETE_CLOUD_BATCH_ERROR: {
      return {
        ...state,
        deleteLabBatchSuccess: false,
        deleteBatchError: true,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    }
    case machineCatalogueActions.CREATE_CLOUD_LAB_SUCCESS: {
      return {
        ...state,
        addLabError: {},
        addLabSuccess: true,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    }
    case machineCatalogueActions.CREATE_CLOUD_LAB_ERROR: {
      return {
        ...state,
        addLabError: action?.payload,
        addLabSuccess: false,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: {},
      };
    }
    case machineCatalogueActions.CREATE_CLOUD_LAB_EXTENISION_SUCCESS: {
      return {
        ...state,
        cloudLabExtensionSuccess: true,
        cloudLabExtensionError: {},
      };
    }
    case machineCatalogueActions.CREATE_CLOUD_LAB_EXTENISION_ERROR: {
      return {
        ...state,
        cloudLabExtensionSuccess: false,
        cloudLabExtensionError: action?.payload,
      };
    }
    case machineCatalogueActions.DELETE_CLOUD_TEMPLATE_SUCCESS: {
      return {
        ...state,
        deleteTemplateSuccess: true,
      };
    }

    case machineCatalogueActions.DELETE_CLOUD_TEMPLATE_ERROR: {
      return {
        ...state,
        deleteTemplateError: action?.payload,
      };
    }

    case machineCatalogueActions.DELETE_LINK_TENANT_SUCCESS: {
      return {
        ...state,
        deletedLinkedTenantSuccess: true,
        activeLinkedTenant: null,
      };
    }
    case machineCatalogueActions.SET_DELETE_LINK_TENANT_LOADING: {
      return {
        ...state,
        deleteLinkTenantLoading: action?.payload,
        activeLinkedTenant: null,
      };
    }
    case machineCatalogueActions.SET_LINK_TENANT_LIST_LOADING: {
      return {
        ...state,
        linkTenantsListLoading: action?.payload,
      };
    }
    case machineCatalogueActions.SET_LINK_TENANT_LOADING: {
      return {
        ...state,
        linkTenantLoading: action?.payload,
      };
    }
    case machineCatalogueActions.CREATE_LINK_TENANT_SUCCESS: {
      return {
        ...state,
        linkTenantSuccess: action?.payload,
        linkTenantError: {},
        activeLinkedTenant: null,
      };
    }
    case machineCatalogueActions.CREATE_LINK_TENANT_ERROR: {
      return {
        ...state,
        linkTenantSuccess: false,
        linkTenantError: action?.payload,
      };
    }

    case machineCatalogueActions.LIST_LINK_TENANT_SUCCESS: {
      return {
        ...state,
        linkTenantList: action?.payload,
        linkTenantListSuccess: true,
        linkTenantListError: false,
        linkTenantSuccess: false,
        linkTenantError: {},
        activeLinkedTenant: null,
      };
    }
    case machineCatalogueActions.RETRIEVE_BY_ID_LINK_TENANT_SUCCESS: {
      return {
        ...state,
        activeLinkedTenant: action?.payload,
      };
    }

    case machineCatalogueActions.SUCCESS_CLOUD_LAB_CREDENTIAL:
      if (state?.labDetails?.cloud_lab_aws) {
        return {
          ...state,
          labDetails: {
            ...state?.labDetails,
            cloud_lab_aws: action?.payload?.data,
          },
        };
      } else {
        return {
          ...state,
          labDetails: {
            ...state?.labDetails,
            cloud_lab_azure: action?.payload?.data,
          },
        };
      }

    case machineCatalogueActions.ERROR_CLOUD_LAB_CREDENTIAL:
      return { ...state, commonError: action?.payload };

    case machineCatalogueActions.DELETE_CLOUD_LAB_SUCCESS:
      return {
        ...state,
        deleteLabSuccess: true,
      };

    case machineCatalogueActions.CLOUD_LAB_RE_PROVISION_SUCCESS: {
      return {
        ...state,
        cloudLabReProvisionSuccess: action?.payload,
      };
    }
    case machineCatalogueActions.CLOUD_LAB_RE_PROVISION_ERROR: {
      return {
        ...state,
        cloudLabReProvisionError: action?.payload,
      };
    }

    case machineCatalogueActions.UPDATE_PERMISSION_POLICY_SUCCESS: {
      return {
        ...state,
        updatePermissionPolicySuccess: action?.payload,
      };
    }
    case machineCatalogueActions.UPDATE_PERMISSION_POLICY_ERROR: {
      return {
        ...state,
        updatePermissionPolicyError: action?.payload,
      };
    }

    case machineCatalogueActions.SET_WORKSPACE_BATCH_REPORTS_LIST_SUCCESS: {
      return {
        ...state,
        workspaceBatchReportsList: action.payload,
        workspaceBatchReportsListError: "",
      };
    }

    case machineCatalogueActions.SET_WORKSPACE_BATCH_REPORTS_LIST_ERROR: {
      return {
        ...state,
        workspaceBatchReportsListError: action.payload,
        workspaceBatchReportsList: {},
      };
    }

    case machineCatalogueActions.RESET_WORKSPACE_BATCH_REPORTS_LIST: {
      return {
        ...state,
        workspaceBatchReportsList: {},
        workspaceBatchReportsListError: "",
      };
    }

    case machineCatalogueActions.SET_WORKSPACE_TENANT_LIST_SUCCESS: {
      return {
        ...state,
        workspaceTenantList: action.payload,
      };
    }

    case machineCatalogueActions.SET_WORKSPACES_LIST_SUCCESS: {
      return {
        ...state,
        workspaces: action.payload,
      };
    }

    case machineCatalogueActions.GENERATE_WORKSPACE_BATCH_REPORT_SUCCESS: {
      return {
        ...state,
        generateWorkspaceBatchReportSuccess: action.payload,
        generateWorkspaceBatchReportError: "",
      };
    }

    case machineCatalogueActions.GENERATE_WORKSPACE_BATCH_REPORT_ERROR: {
      return {
        ...state,
        generateWorkspaceBatchReportError: action.payload,
        generateWorkspaceBatchReportSuccess: "",
      };
    }

    case machineCatalogueActions.RESET_WORKSPACE_BATCH_REPORTS_FORM: {
      return {
        ...state,
        workspaceTenantList: "",
        workspaces: "",
      };
    }

    // Azure Report Download Report
    case machineCatalogueActions.AZURE_REPORT_DOWNLOAD_ACTION:
      return {
        ...state,
        azureReportLoading: true,
      };
    case machineCatalogueActions.AZURE_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        azureReportLoading: false,
        azureReportSuccess: true,
        azureReportData: action?.payload || [],
      };
    case machineCatalogueActions.AZURE_REPORT_DOWNLOAD_ERROR:
      return {
        ...state,
        azureReportLoading: false,
        azureReportSuccess: false,
      };
    case machineCatalogueActions.AZURE_REPORT_DOWNLOAD_RESET:
      return {
        ...state,
        azureReportLoading: false,
        azureReportSuccess: false,
        azureReportData: [],
      };

    // Clean Up Azure 
    case machineCatalogueActions.CLEAN_UP_AZURE_ACTION:
      return {
        ...state,
        cleanUpAzureLoading: true,
      };
    case machineCatalogueActions.CLEAN_UP_AZURE_SUCCESS:
      return {
        ...state,
        cleanUpAzureLoading: false,
        cleanUpAzureSuccess: true,
      };
    case machineCatalogueActions.CLEAN_UP_AZURE_ERROR:
      return {
        ...state,
        cleanUpAzureLoading: false,
        cleanUpAzureSuccess: false,
      };
    case machineCatalogueActions.CLEAN_UP_AZURE_RESET:
      return {
        ...state,
        cleanUpAzureLoading: false,
        cleanUpAzureSuccess: false,
      };

    case machineCatalogueActions.SYNC_BILL_SUCCESS:
      return {
        ...state,
        standAloneLabs: {
          ...state.standAloneLabs,
          results: state.standAloneLabs?.results?.map((lab) =>
            lab.id === action.payload?.id
              ? { ...lab, available_credit: action.payload?.available_credit }
              : lab
          ),
        },
      };

    case machineCatalogueActions.SYNC_BILL_ERROR:
      return {
        ...state,
        commonError: action?.payload,
      };

    // AWS Account cleaning
    case machineCatalogueActions.AWS_CLEANUP_ACTION:
      return {
        ...state,
        awsCleanupLoading: true,
      };
    case machineCatalogueActions.AWS_CLEANUP_SUCCESS:
      return {
        ...state,
        awsCleanupLoading: false,
        awsCleanupSuccess: true,
        awsCleanupData: action?.payload || [],
      };
    case machineCatalogueActions.AWS_CLEANUP_ERROR:
      return {
        ...state,
        awsCleanupLoading: false,
        awsCleanupSuccess: false,
        awsCleanupError: true
      };
    case machineCatalogueActions.AWS_CLEANUP_RESET:
      return {
        ...state,
        awsCleanupLoading: false,
        awsCleanupSuccess: false,
        awsCleanupData: {},
      };
    case machineCatalogueActions.GET_MENTOR_LIST:
      return {
        ...state,
        mentorListLoading: true,
        mentorListError: null,
      };
    case machineCatalogueActions.GET_MENTOR_LIST_SUCCESS:
      return {
        ...state,
        mentorListLoading: false,
        mentorList: action.payload,
      };
    case machineCatalogueActions.GET_MENTOR_LIST_ERROR:
      return {
        ...state,
        mentorListLoading: false,
        mentorListError: action.payload,
      };
    case machineCatalogueActions.RESET_MENTOR_LIST:
      return {
        ...state,
        mentorListLoading: false,
        mentorList: [],
        mentorListError: null,
      };

    default:
      return state;
  }
};

export default resourceManager;
